enum ListType {
  Weather = 'weather',
  AdditiveMaterialTypeName = 'additiveMaterialTypeName',
  TimeSequence = 'timeSequence',
}

export default ListType;
